<template>
  <RouterLink :to="to" class="prm title-small-regular">
    <i class="fa-solid fa-circle-user"></i>
    PRM
  </RouterLink>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  level: {
    type: String,
    required: true,
  },
});

const to = computed(() =>
  props.level === "national"
    ? `/prm-national/${props.id}`
    : `/prm-regional/${props.id}`
);
</script>

<style lang="scss" scoped>
.prm {
  display: flex;
  flex-direction: row;
  gap: 2px;

  i {
    font-size: 1.188rem;
  }

  &:focus-visible {
    box-shadow: 0 0 5px 2px #a802e3;
    outline: 2px solid #a802e3;
    border-radius: 4px;
    padding: 4px 2px;
  }
}
</style>
